/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Default_Payment_ProviderInputs */

const en_admin_settings_fields_default_payment_provider = /** @type {(inputs: Admin_Settings_Fields_Default_Payment_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default provider`)
};

/**
* | output |
* | --- |
* | "Default provider" |
*
* @param {Admin_Settings_Fields_Default_Payment_ProviderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_default_payment_provider = /** @type {((inputs?: Admin_Settings_Fields_Default_Payment_ProviderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Default_Payment_ProviderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_default_payment_provider(inputs)
});
export { admin_settings_fields_default_payment_provider as "admin.settings.fields.default_payment_provider" }